/* eslint-disable warp-drive/no-legacy-request-patterns */
// Extends From

import Route from '@ember/routing/route';

// Internal Imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import PostStatus from '@linc-technologies/linced-common/enums/post-status';

// Ember Imports
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

// External Imports
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class PageRoute extends Route {
  queryParams = {
    authorIds: {
      refreshModel: true,
    },
    autoFilter: {
      refreshModel: true,
    },
    endTime: {
      refreshModel: true,
    },
    groupIds: {
      refreshModel: true,
    },
    offset: {
      refreshModel: true,
    },
    searchQuery: {
      refreshModel: true,
    },
    startTime: {
      refreshModel: true,
    },
    personIds: {
      refreshModel: true,
    },
    status: {
      refreshModel: true,
    },
  };

  // Services
  @service
  dates;

  @service
  router;

  @service
  store;

  @service
  toaster;

  // State
  // caregiversLoaded attempts to stop reloading caregivers as pagination
  // changes.
  caregiversLoaded = false;

  model(params) {
    let offset = 0;
    if (!isEmpty(params.offset)) {
      let temp = Number(params.offset);
      if (!Number.isNaN(temp) && temp > 0) {
        offset = temp;
      }
    }
    let statuses = [];
    if (params.status !== 0) {
      if (parseInt(params.status) === PostStatus.DRAFT) {
        statuses = JSON.stringify([PostStatus.DRAFT, PostStatus.UNPUBLISHED]);
      } else {
        statuses = JSON.stringify([PostStatus.PUBLISHED]);
      }
    }
    let authorIds = '';
    if (!isEmpty(params.authorIds)) {
      authorIds = JSON.stringify(params.authorIds);
    }
    let groupIds = '';
    if (!isEmpty(params.groupIds)) {
      groupIds = JSON.stringify(params.groupIds);
    }
    let personIds = '';
    if (!isEmpty(params.personIds)) {
      personIds = JSON.stringify(params.personIds);
    }
    let searchQuery = '';
    if (!isEmpty(params.searchQuery)) {
      searchQuery = params.searchQuery;
    }
    let startTime = 0;
    if (!isEmpty(params.startTime)) {
      startTime = moment(params.startTime).startOf('day').unix();
    }
    let endTime = 0;
    if (!isEmpty(params.endTime)) {
      endTime = moment(params.endTime).endOf('day').unix();
    }
    if (!isEmpty(params.autoFilter)) {
      switch (params.autoFilter) {
        case 'day':
          startTime = moment().startOf('day').unix();
          endTime = moment().endOf('day').unix();
          break;
        case 'week':
          startTime = moment().startOf('week').unix();
          endTime = moment().endOf('week').unix();
          break;
        case '7-days':
          startTime = moment().subtract(7, 'days').startOf('day').unix();
          endTime = moment().endOf('day').unix();
          break;
        default:
          this.toaster.error('Invalid Auto Filtering Option');
          break;
      }
    }

    return hash({
      page: this.store.findRecord('posts/page', params.page_id),
      posts: this.store.query('posts/post', {
        pageId: params.page_id,
        perPage: 20,
        authorIds,
        endTime,
        groupIds,
        personIds,
        offset,
        searchQuery,
        startTime,
        statuses,
        include: 'reactions,comments,commentAuthors',
      }),
      authors: this.store.query('person', {
        type: PersonType.STAFF,
      }),
      update: () => this.refresh(),
    });
  }
}
